import { fuseDark, skyBlue } from '@fuse/colors';
import { lightBlue, red } from '@material-ui/core/colors';

/* TURP Colors */

// faded_red: #d9333e
// pale_rose: #f9cfd4
// twilight : #47488e
// inactive: #a9abbd
// pale_grey: #dcdaeb
// purple_brown: #2d222b
// warm_grey: #707070
// white: #fcfcfc
// success: #04da91
// error: #ff2300

const lightText = {
  primary: 'rgb(17, 24, 39)',
  secondary: 'rgb(107, 114, 128)',
  disabled: 'rgb(149, 156, 169)'
};

const darkText = {
  primary: 'rgb(255,255,255)',
  secondary: 'rgb(229, 231, 235)',
  disabled: 'rgb(156, 163, 175)'
};

const themesConfig = {
  default: {
    palette: {
      type: 'light',
      text: lightText,
      common: {
        black: 'rgb(17, 24, 39)',
        white: 'rgb(255, 255, 255)'
      },
      primary: fuseDark,
      secondary: {
        light: lightBlue[400],
        main: lightBlue[600],
        dark: lightBlue[700]
      },
      background: {
        paper: '#FFFFFF',
        default: '#f6f7f9'
      },
      error: red
    },
    status: {
      danger: 'orange'
    }
  },
  defaultDark: {
    palette: {
      type: 'dark',
      text: darkText,
      primary: fuseDark,
      secondary: {
        light: lightBlue[400],
        main: lightBlue[600],
        dark: lightBlue[700]
      },
      background: {
        paper: '#1E2125',
        default: '#121212'
      },
      error: red
    },
    status: {
      danger: 'orange'
    }
  },

  /* Default Theme */

  turpLight: {
    palette: {
      type: 'light',
      text: lightText,
      primary: {
        light: '#F9CFD4',
        main: '#FF445D',
        dark: '#D9333E'
      },
      secondary: {
        light: '#B4E3FB',
        main: '#05A2F3',
        dark: '#0175EA',
        contrastText: '#FCFCFC'
      },
      background: {
        paper: '#FCFCFC',
        default: '#F6F7F9'
      },
      success: {
        main: '#04da91'
      },
      error: {
        main: '#ff2300'
      }
    },
    status: {
      danger: 'orange'
    }
  }
};

export default themesConfig;
